import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { classNames } from "../../utils/helpers";
import { Button } from "../button";
import { ChevronRight, ChevronLeft } from '@az/starc-ui-icons';
import { useIsomorphicLayoutEffect } from "../../hooks/useIsomorphicLayoutEffect";
import s from './Carousel.module.css';
export const CarouselControl = ({ type, scrollElRef, scrollPosition, onClick, mounted, buttonTitle, }) => {
    const [visible, setVisible] = React.useState(false);
    const isNext = type === 'forward';
    const isDisplayedAsNext = type === 'forward';
    const controlClassNames = classNames(s.control, isDisplayedAsNext ? s['--control-next'] : s['--control-prev'], visible && s['--control-visible']);
    const controlButtonClassNames = classNames(s.controlButton, s['--button'], !visible && s['--button-disabled']);
    useIsomorphicLayoutEffect(() => {
        const scrollEl = scrollElRef.current;
        if (!scrollEl || !mounted)
            return;
        // TODO: use Resize component once that is complete : https://track.autozone.com/browse/STAR-1849
        const normalizedScrollPosition = Math.abs(scrollPosition);
        const isScrollAtStart = normalizedScrollPosition <= 0;
        const isScrollAtEnd = normalizedScrollPosition + scrollEl.clientWidth >= scrollEl.scrollWidth - 1;
        const hideControl = isNext ? isScrollAtEnd : isScrollAtStart;
        if (hideControl) {
            setVisible(false);
        }
        else {
            setVisible(true);
        }
    }, [scrollPosition, scrollElRef, mounted]);
    return (_jsx("div", { className: controlClassNames, "data-testid": "st-carousel-control", children: _jsx(Button, { className: controlButtonClassNames, onClick: onClick, startIcon: isDisplayedAsNext ? ChevronRight : ChevronLeft, title: buttonTitle, variant: "ghost", attributes: { 'aria-disabled': !visible, 'aria-label': buttonTitle } }) }));
};
